module.exports = __webpack_public_path__ + "static/media/excel-loading.9cc63f72.gif";